import React from 'react'
import moment from 'moment'

import {
    toWeekDaysArrayFull,
    toDatesArray
} from '../../../../helpers/moment'

const MonthView = ({ 
    shifts,
    activeDate, 
    activeMonth,
    startDay,
    backToToday,
    changeActiveDate,
    changeToNextMonth,
    changeToPrevMonth
}) => {
    let activeClass = "  bg-brand text-white shadow-sm"
    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between">
                <div>
                    <div className="py-2">{moment(activeMonth.startDate).format('MMMM')}</div>
                    <h5>{moment(activeDate).format('DD MMMM YYYY')}</h5>
                </div>
                <div className="text-right" style={{minWidth: '95px'}}>
                    <button 
                        className="btn btn-light text-dark border bg-white p-1 mr-2"
                        onClick={() => changeToPrevMonth(activeMonth.startDate, activeMonth.endDate)}
                        style={{
                            borderRadius: '50%',
                            height: '25px',
                            width: '25px',
                            lineHeight: '1.1rem'
                        }}><i className="fas fa-chevron-left"></i></button>
                        <button
                            className="btn btn-light text-dark border bg-white p-1"
                            onClick={() => backToToday()}
                            style={{
                                borderRadius: '50%',
                                height: '25px',
                                width: '25px',
                                lineHeight: '1.1rem'
                            }}>
                            <i className="far fa-circle"></i>
                        </button>
                    <button 
                        className="btn btn-light text-dark border bg-white p-1 ml-2"
                        onClick={() => changeToNextMonth(activeMonth.startDate, activeMonth.endDate)}
                        style={{
                            borderRadius: '50%',
                            height: '25px',
                            width: '25px',
                            lineHeight: '1.1rem'
                        }}><i className="fas fa-chevron-right"></i></button>
                </div>
            </div>
            <div className="rounded mb-3" style={{backgroundColor: '#fafafa'}}>
                <h6 className="text-center pt-3">{activeMonth && moment(activeMonth.startDate).format('MMMM, YYYY')}</h6>
                <div className="d-flex justify-items-center flex-wrap">
                    {
                        activeMonth && toWeekDaysArrayFull(moment(activeMonth.startDate), startDay).map(day => (
                            <div key={day} className="flex-grow-1 pb-3 text-center text-muted" style={{flex: '0 13%'}}>{moment(day).format('dd')}</div>
                        ))
                    }
                    { 
                        activeMonth && toDatesArray(moment(activeMonth.calendarStartDate), moment(activeMonth.calendarEndDate)).map((date, index) => (
                            <div 
                                key={index} 
                                className="flex-grow-1 mb-3 text-center"
                                onClick={() => changeActiveDate(moment(date).format('YYYY-MM-DD'))}
                                style={{flex: '0 13%'}}>
                                <div 
                                    className={"pt-1 m-auto" + (moment(date).format('YYYY-MM-DD') === moment(activeDate).format('YYYY-MM-DD') ? activeClass : "")}
                                    style={
                                        {
                                            borderRadius: '50%', 
                                            height: '30px', 
                                            width: '30px',
                                            textAlign: 'center',
                                            lineHeight: '1.6rem',
                                        }
                                    }
                                >
                                    <div style={(moment(activeMonth.startDate).format('MM') !== moment(date).format('MM')) ? {color: '#d9d9d9'} : {}}>{moment(date).format('DD')}</div>
                                </div>
                            </div>
                        )) 
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

export default MonthView
